import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import AdminApp from './AdminApp.jsx';
import './index.css';

// Aangan has three top-level app shells that never render simultaneously:
//   - V1 (default): consumer groups + businesses, entry at "/"
//   - V2 (in development): gated behind ?v2= URL params
//   - Admin (operations panel): gated behind ?admin=1
// Capacitor Android opens at "/" with no params, so both V2 and Admin ship
// dormant on Play Store builds — the Play Store consumer app cannot reach
// either surface. Admin is browser-only by design.
const isAdminUrl = new URLSearchParams(window.location.search).get('admin') === '1';

ReactDOM.createRoot(document.getElementById('root')).render(
  isAdminUrl ? <AdminApp /> : <App />
);
